import { Digest } from '@Monitor/Briefings/models/digest.model';


export class DigestRow {

    digest: Digest;

    name: string;
    selected: boolean = false;

    createdByUser: string;
    createdDate: string;

    modifiedByUser: string;
    modifiedDate: string;

    createdDateRaw: number;
    modifiedDateRaw: number;

    constructor({
        digest,
        createdDate,
        createdByUser,
        modifiedByUser,
        modifiedDate,
        createdDateRaw,
        modifiedDateRaw
    }: {
        digest: Digest;
        createdDate: string;
        createdByUser: string;
        modifiedByUser: string;
        modifiedDate: string;
        createdDateRaw: number;
        modifiedDateRaw: number;
    }) {
        this.digest = digest;
        this.name = digest.name;

        this.createdDate = createdDate;
        this.createdByUser = createdByUser;

        this.modifiedByUser = modifiedByUser;
        this.modifiedDate = modifiedDate;

        this.createdDateRaw = createdDateRaw;
        this.modifiedDateRaw = modifiedDateRaw;
    }
}
